require("../common/input_mask");

require("./form");

const Header = require("./header");

$(function () {
  Header();

  const $job_board = $("#job-board"),
    $titles = $job_board.find(".titles > ul >li"),
    $jobs = $job_board.find(".descriptions > li"),
    $joblink = $jobs.find("a.btn");

  $joblink.each(function () {
    //Sets job title as mailto subject
    $(this).attr(
      "href",
      $(this).attr("href") + " : " + $(this).siblings("h3").text(),
    );
  });

  $('input[name="job[category]"]').on("change", function () {
    const $filtered_categories = $titles.filter("." + $(this).val());

    $job_board.toggleClass("animate");
    $titles.removeClass("visible");
    $filtered_categories.addClass("visible");
    $filtered_categories.first().find("a").click();
  });

  $titles.find("a").on("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    $job_board.toggleClass("animate");

    const target = "#" + $(this).data("job");
    history.replaceState(null, null, event.target); // Update URL
    $titles.filter(".selected").removeClass("selected");
    $(this).parent().addClass("selected");
    $jobs.removeClass("selected").filter(target).addClass("selected");
  });
});
